import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { colorsFoundation } from "../tokens/colors-foundation.js";
import { hexToRgba } from "../utils/colors.js";

/**
 * Sparkline — the click-dummy's mini bar chart used inside KPI cards. A row of
 * small rounded bars scaled to the data. Single-hue (brand primary by default)
 * so it reads as a decorative trend, not a full chart. Recolours per skin.
 */
export default function Sparkline({ data = [], tone, height = 34 }) {
  const color = tone ?? colorsFoundation.key.blue[500];
  const max = Math.max(...data, 1);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        gap: "2px",
        height,
        width: "100%",
      }}
    >
      {data.map((value, i) => {
        // Bars flex to fill the full card width (like the Schadenaufkommen chart);
        // the most recent bar is fully saturated, older bars fade back.
        const recency = data.length > 1 ? i / (data.length - 1) : 1;
        return (
          <Box
            key={i}
            sx={{
              flex: 1,
              height: `${Math.max((value / max) * 100, 4)}%`,
              minHeight: "3px",
              borderRadius: "3px 3px 0 0",
              backgroundColor: hexToRgba(color, 0.35 + recency * 0.65),
            }}
          />
        );
      })}
    </Box>
  );
}

Sparkline.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number),
  tone: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
